import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-asset_library_new",
  "use": "icon-asset_library_new-usage",
  "viewBox": "0 0 18 20",
  "content": "<symbol viewBox=\"0 0 18 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-asset_library_new\">\n<path d=\"M0 0.9918C0 0.44405 0.44495 0 0.9934 0H17.0066C17.5552 0 18 0.45531 18 0.9918V19.0082C18 19.556 17.5551 20 17.0066 20H0.9934C0.44476 20 0 19.5447 0 19.0082V0.9918ZM16 9V2H2V9H16ZM16 11H2V18H16V11ZM6 4H12V6H6V4ZM6 13H12V15H6V13Z\" fill=\"#666666\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol